module.exports = __webpack_public_path__ + "img/alarm_button_on.f4af915f.svg";